import React from 'react'
import ReactDOM from 'react-dom'
import { Provider, } from 'react-redux'
import 'normalize.css'

import createStore from './redux/createStore'
import SceneManager from './components/_sceneManager'
// import registerServiceWorker from './registerServiceWorker'

import './styles/index.css'

const store = createStore()

ReactDOM.render(
  <Provider store={store}>
    <SceneManager />
  </Provider>,
  document.getElementById('root')
)
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js